


















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Integrations } from '../enums/integrations';
import { IntegrationApiKeys } from '../classes/integrationApiKeys';
import { ElForm } from 'node_modules/element-ui/types/form';
import { IntegrationApi } from '@/modules/integrations/api/integrations';
import { IntegrationDefinitionVm } from '@/modules/integrations/classes/integrationDefinitionVm';
import { WizardQueryParams } from '../classes/wizardQueryParams';

@Component({
  components: {},
})
export default class ApiKeys extends Vue {
    @Prop() public integration!: Integrations;
    public form: IntegrationApiKeys = new IntegrationApiKeys();
    public formRules!: any;
    private api!: IntegrationApi;
    public integrationDefinition?: IntegrationDefinitionVm;
    @Prop() public wizardQueryParams!: WizardQueryParams;

    public clientId?: string;
    public clientSecret?: string;
    public authorizationCode?: string;
    public apiEndpoint?: string;

    constructor() {
        super();
        this.api = new IntegrationApi();
    }
    public async created() {
        this.integrationDefinition = await this.getIntegrationDefinition();
        if(this.isApilo())
        {
            this.setApilloFields();
            this.updateApiKey();
        }
        this.formRules = {
            url: [
                { required: this.isUrlVisible(), message: this.$t('forms.required'), trigger: 'blur' },
                {
                    trigger: 'blur',
                    validator: (rule: any, value: string, callback: (error?: Error) => void) => {
                        if (this.isUrlValid(value)) {
                            callback();
                        } else {
                            callback(new Error(this.$t('forms.wrongUrl') as string));
                        }
                    },
                },
            ],
            apiKey: [
                { required: true, message: this.$t('forms.required'), trigger: 'blur' },
            ],
        };

    }

  public async getIntegrationDefinition() : Promise<IntegrationDefinitionVm | undefined> {
    const integration = (await this.api.getIntegrationsDefinitions()).find(
      (n) => n.name.toLocaleLowerCase() == this.integration.toLocaleLowerCase()
    );
    return integration;
  }

    public updateApiKey() {
        this.updateApiKeysData();
    }

    public updateApiKeysData() {
        this.$emit('update', this.form);
    }

    public async validateForm() {
        return new Promise((resolve, reject) => {
            (this.$refs.form as ElForm).validate((isValid: boolean, invalidFields: object) => {
                resolve(isValid);
            });
        });
    }
    public getIntegrationGuideUrl() : string {
        if(this.integrationDefinition?.helpUrl)
        {
            return this.integrationDefinition.helpUrl;
        }
        return 'https://labelcall.com/'
    }
    public isUrlVisible() {
        if (this.integration === Integrations.PRESTASHOP) {
            return true;
        }

        return false;
    }
    public getVideoExplainer() : string | undefined {
        return this.integrationDefinition?.videoExplainer;
    }
    public isUrlValid(url: string): boolean {
        const pattern = new RegExp('^(https?:\\/\\/)' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3})|' + // OR ip (v4) address
            '(localhost))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'); // port and path
        return !!pattern.test(url);
    }

    public isApilo() : boolean{
        return this.integration === Integrations.APILO;
    }

    private setApilloFields()
    {
        this.clientId = this.wizardQueryParams?.clientId ?? '';
        this.clientSecret = this.wizardQueryParams?.clientSecret ?? '';
        this.authorizationCode = this.wizardQueryParams?.authorizationCode ?? '';
        this.apiEndpoint = this.wizardQueryParams?.apiEndpoint ?? '';

        this.form.clientId = this.clientId;
        this.form.clientSecret = this.clientSecret;
        this.form.authorizationCode = this.authorizationCode;
        this.form.url = this.apiEndpoint;
    }
}
